/**
 * shipmentKanbanColumns - Colunas fixas do Kanban de Remessas (1:1 com as situações).
 *
 * Ordem derivada de SHIPMENT_STATUS_ORDER e rótulos de SHIPMENT_STATUS_META, para
 * nunca divergir da listagem/modal. As cores seguem a trilha (azul que escurece
 * ao avançar, verde na entrega, vermelho em extravio/devolução, cinza no cancelamento).
 *
 * RELEASE: 2026-10-16 v1.0.0 - Versão inicial.
 */
import { SHIPMENT_STATUS_META, SHIPMENT_STATUS_ORDER, type ShipmentStatus } from '../shipmentStatus';

export interface ShipmentKanbanColumnDef {
  status: ShipmentStatus;
  label: string;
  barClass: string;
  headerClass: string;
}

/** Classes estáticas (o Tailwind não gera classes a partir de hex dinâmico). */
const TONES: Record<ShipmentStatus, { bar: string; header: string }> = {
  draft: { bar: 'bg-blue-400', header: 'bg-blue-400/10' },
  preparing: { bar: 'bg-blue-500', header: 'bg-blue-500/10' },
  ready: { bar: 'bg-blue-600', header: 'bg-blue-600/10' },
  shipped: { bar: 'bg-blue-700', header: 'bg-blue-700/10' },
  in_transit: { bar: 'bg-blue-800', header: 'bg-blue-800/10' },
  delivered: { bar: 'bg-green-600', header: 'bg-green-600/10' },
  lost: { bar: 'bg-destructive', header: 'bg-destructive/10' },
  returned_to_sender: { bar: 'bg-destructive', header: 'bg-destructive/10' },
  cancelled: { bar: 'bg-muted-foreground/40', header: 'bg-muted-foreground/10' },
};

export const SHIPMENT_KANBAN_COLUMNS: ShipmentKanbanColumnDef[] = SHIPMENT_STATUS_ORDER.map((status) => ({
  status,
  label: SHIPMENT_STATUS_META[status].label,
  barClass: TONES[status].bar,
  headerClass: TONES[status].header,
}));
